export default {
  listTitleIndexTable: {
    TICKER: 'MÃ',
    REFERENCE_PRICE: 'GIÁ TC',
    MATCH_PRICE: 'GIÁ KHỚP',
    PRICE_CHANGE: '+/-',
    D_CHANGE: '% ',
    TOTAL_MATCH_VOLUME: 'TỔNG KL',
    TOTAL_MATCH_VALUE: 'TỔNG GT',
    NET_FOREIGN_VOLUME_TOTAL: 'KLNN RÒNG',
    CLOSE_PRICE: 'TREND',
    DAY_RANGE: 'BIẾN ĐỘNG NGÀY', // calculate from LowestPrice, HighestPrice, MatchPrice, ReferencePrice
    PERFORMANCE: 'DIỄN BIẾN GIÁ', // calculate MatchPrice, ReferencePrice
    RANKING: 'XẾP HẠNG',
    ORGAN_SHORT_NAME: 'TÊN D.N',
    COM_GROUP_CODE: 'SÀN',
    DEAL_PRICE: 'GIÁ THỎA THUẬN',
    TOTAL_DEAL_VOLUME: 'KL THỎA THUẬN',
    TOTAL_DEAL_VALUE: 'GT THỎA THUẬN',
    BEST_1_BID: 'GIÁ MUA 1',
    BEST_1_OFFER: 'GIÁ BÁN 1',
    CEILING_PRICE: 'GIÁ TRẦN',
    FLOOR_PRICE: 'GIÁ SÀN',
    OPEN_PRICE: 'MỞ CỬA',
    HIGHEST_PRICE: 'CAO NHẤT',
    LOWEST_PRICE: 'THẤP NHẤT',
    AVERAGE_PRICE: 'GIÁ TB',
    _52W_RANGE: 'BIẾN ĐỘNG 52W',
    TOTAL_VOLUME: 'TỔNG KL',
    TOTAL_VALUE: 'TỔNG GT',
    TOTAL_BUY_TRADE_VOLUME: 'DƯ MUA',
    TOTAL_SELL_TRADE_VOLUME: 'DƯ BÁN',
    FOREIGN_BUY_VOLUME_TOTAL: 'KLNN MUA',
    FOREIGN_BUY_VALUE_TOTAL: 'GTNN MUA',
    FOREIGN_SELL_VOLUME_TOTAL: 'KLNN BÁN',
    FOREIGN_SELL_VALUE_TOTAL: 'GTNN BÁN',
    FOREIGN_CURRENT_ROOM: 'ROOM NN',
    FOREIGN_NET_VOLUME_TOTAL: 'KLNN RÒNG',
    FOREIGN_NET_VALUE_TOTAL: 'GTNN RÒNG',
    FREE_FLOAT: 'FREE FLOAT',
    FREE_FLOAT_RATE: '% FREE FLOAT',
    RTD19: 'BETA 2Y',
    AVERAGE_MATCHED_VOLUME_2WEEK: 'KL KHỚP TB 10D',
    AVERAGE_MATCHED_VOLUME_1MONTH: 'KL KHỚP TB 1M',
    AVERAGE_MATCHED_VOLUME_3MONTH: 'KL KHỚP TB 3M',
    PERCENT_PRICE_CHANGE_1WEEK: '% GIÁ 1W',
    PERCENT_PRICE_CHANGE_1MONTH: '% GIÁ 1M',
    PERCENT_PRICE_CHANGE_3MONTH: '% GIÁ 3M',
    PERCENT_PRICE_CHANGE_1YEAR: '% GIÁ 1Y',

    PUT_THROUGH_PRICE: 'GIÁ THỎA THUẬN',
    ONE_YEAR_HIGH: 'CAO NHẤT 1Y',
    ONE_YEAR_LOW: 'THẤP NHẤT 1Y',
    MATCH_VOLUME: 'KL KHỚP',
    MATCH_VALUE: 'GT KHỚP',
    AVERAGE_MATCHED_VOLUME_1YEAR: 'KL KHỚP TB 1Y',
  },

  listTitleDerivativeTable: {
    DERIVATIVE_CODE: 'MÃ', // Ticker
    LAST_TRADING_DATE: 'NGÀY ĐH', // Expiry date
    REFERENCE_PRICE: 'GIÁ TC', // Ref
    MATCHED: 'GIÁ KHỚP', // MatchPrice and CurrentPrice
    MATCH_VOLUME: 'TỔNG KL', // Volume
    BEST_1_BID: 'GIÁ MUA 1', // Best bid
    BEST_1_OFFER: 'GIÁ BÁN 1', // Best ask
    TOTAL_SELL_TRADE_VOLUME: 'DƯ MUA', // Unmatched sell
    TOTAL_BUY_TRADE_VOLUME: 'DƯ BÁN', // Unmatched buy
    BASIS: 'ĐỘ LỆCH', // basic = matched - matchPrice
    OPEN_INTEREST: 'KL MỞ', // OI
    DAY_RANGE: 'BIẾN ĐỘNG NGÀY', // dayRange: lowestPrice, highestPrice
    CEILING_PRICE: 'TRẦN', // Ceil
    FLOOR_PRICE: 'SÀN', // Floor
    OPEN_PRICE: 'MỞ CỬA', // Open
    HIGHEST_PRICE: 'CAO', // High
    LOWEST_PRICE: 'THẤP', // Low
    PRICE_CHANGE: '+/-', // Low
    FOREIGN_BUY_VOLUME_MATCHED: 'KLNN MUA', // Foreign buy Vol.
    FOREIGN_SELL_VOLUME_MATCHED: 'KLNN BÁN', // Foreign sell Vol.
  },

  listTitlePutThroughMatchedTable: {
    TICKER: 'MÃ',
    DEAL_PRICE: 'GIÁ',
    DEAL_VOLUME: 'KL',
    DEAL_VALUE: 'GT',
    TOTAL_DEAL_VALUE: 'GT CỘNG DỒN',
    TRADING_DATE: 'THỜI GIAN',
  },

  movingAveragePrice: {
    daily: 'NGÀY',
    weekly: 'TUẦN',
    monthly: 'THÁNG',
    quarterly: 'NĂM',
  },

  confirmDelete: 'Xác Nhận Xóa?',
  manageColumn: 'Thêm cột chỉ tiêu',
  clearAll: 'Bỏ Chọn Tất Cả',
  resetToDefault: 'Đặt Lại Mặc Định',

  viewChartIcon: 'Xem dạng Đồ Thị',
  viewTableIcon: 'Xem dạng Bảng',
  createNewWatchlistIcon: 'Tạo danh mục mới',
  settingIcon: 'Cài đặt',
  tooltipItemCompanyGroup: 'Top 100 DN Theo Vốn Hóa',
  nameYourWatchlist: 'Tên Danh Mục',

  dayRangeTooltip: 'Phạm vi ngày: %{lowestPrice} - %{highestPrice}',
  dayRangeLast: 'Giá cuối: %{matchPrice}',
  dayRangeRef: 'Giá tham khảo: %{referencePrice}',

  yearRangeTooltip: 'Phạm vi năm: %{lowestPrice} - %{highestPrice}',

  listTitleTablePutThrough: {
    hose: 'HOSE',
    hnx: 'HNX',
    upcom: 'UPCOM',
  },
};
